const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const

/**
 * Formats a byte count with binary units (1 KB = 1024 B) labelled B/KB/MB/GB/TB.
 * Matches the platform convention that 100 MB = 104,857,600 bytes. One decimal is
 * shown for values below 100 of a unit; a trailing ".0" is dropped.
 */
export function formatBytes(bytes: number): string {
  const safe = Number.isFinite(bytes) && bytes > 0 ? bytes : 0
  let value = safe
  let unitIndex = 0
  while (value >= 1024 && unitIndex < UNITS.length - 1) {
    value /= 1024
    unitIndex += 1
  }
  if (unitIndex === 0) {
    return `${Math.round(value)} ${UNITS[0]}`
  }
  const rounded = value >= 100 ? Math.round(value) : Math.round(value * 10) / 10
  return `${rounded} ${UNITS[unitIndex]}`
}
